// Material Kit 2 React examples
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
// Author page sections
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

//react router dom
import { Link } from "react-router-dom";

import noticias from "data/noticiasData";

export default function NoticiasPage() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/afiliate",
          label: "Afiliate",
          color: "info",
        }}
        transparent
        light
      />
      <MKBox bgColor="white">
        {/* HEADER */}
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage:
              'url("https://i.pinimg.com/1200x/ec/cb/72/eccb727dfd9ab2a6c815da1a63c868e1.jpg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />

        {/* GRID DE NOTICIAS */}
        <MKBox px={3} py={6}>
          <Grid container spacing={4}>
            {noticias.map((item) => (
              <Grid item xs={12} md={6} lg={4} key={item.id}>
                <Card>
                  <CardMedia component="img" height="200" image={item.foto} alt={item.titulo} />

                  <CardContent>
                    <Typography variant="caption" color="text.secondary">
                      {item.fecha}
                    </Typography>

                    <Typography gutterBottom variant="h5">
                      {item.titulo}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      {item.epigrafe}
                    </Typography>
                  </CardContent>

                  <CardActions>
                    <Button
                      sx={{
                        color: "white !important",
                      }}
                      component={Link}
                      to={`/noticias/${item.id}`}
                      size="small"
                      variant="contained"
                    >
                      Ver más
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </MKBox>

        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </MKBox>
    </>
  );
}
